<template>
    <transition name="fade">
        <div v-if="isVisible" id="outline_continuous" @click.self="maskClickEvn">
            <div class="outline_continuous">
                <div class="outline_continuous1">
                    续写分卷
                    <img class="cursor_1" @click="closePopup" src="@/assets/image/icon_close.png" alt="">
                </div>
                <div class="outline_continuous2" v-if="showPlot">
                    <div class="outline_continuous3">
                        下文情节设定<span>（非必填）</span>
                    </div>
                    <div class="outline_continuous4 cursor_1" @click="aiPlot"></div>
                    <img src="@/assets/image/loading.png" alt="" v-if="streamStatus" class="outline_loading t-m-l-5">
                </div>
                <div class="outline_continuous5" v-if="showPlot">
                    <el-input v-model="plot" type="textarea" show-word-limit maxlength="5000"
                        :autosize="{ minRows: 6, maxRows: 8 }" placeholder="请输入下文故事情节，AI会按照您的思路进行创作"></el-input>
                    <div class="outline_continuous6">
                        <img src="@/assets/image/icon_del.png" class="cursor_1" alt="" @click="clearText()">
                    </div>
                    <!-- 停止生成按钮 -->
                    <AIStopCreate plain :hide="streamStatus" emit @stop="clearTimer" bottom="10px"></AIStopCreate>
                </div>
                <div class="outline_continuous2">
                    <div class="outline_continuous3">
                        <span>*</span> 续写卷数
                    </div>
                </div>
                <el-input v-model="chapter" type="number" placeholder="请输入想要续写的卷数(1-5)"></el-input>
                <div class="outline_continuous7">
                    <div class="outline_continuous8 cursor_1" @click="aiGenerateoutline">AI生成</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/api/api'
import lNApi from '@/api/longNovel'
export default {
    props: {
        maskClick: {
            type: Boolean,
            default: true
        },
        novelId: {
            type: String | Number,
            default: ''
        }
    },
    data() {
        return {
            isVisible: false,
            chapter: "",
            plot: '',
            streamStatus: false, // 流式请求 false请求结束 true请求
            streamIndex: 0, // 流式请求下标
            debounceTimer: null, // 防抖定时器
            typingTimer: null, // 打字效果定时器
            maxChapter: 5,//最多分卷数
            isStop: false,
            showPlot: false,//是否显示上下文情节设定
        }
    },
    methods: {
        clearTimer(status) {
            console.log('销毁定时器')
            if (status) {
                this.isStop = true
            }
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
            this.streamIndex = 0
            this.streamStatus = false;
            localStorage.removeItem('AICreateId')
        },
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        clearText() {
            this.plot = ''
        },
        closePopup() {
            this.isVisible = false;
        },
        openPopup(showPlot = false) {
            this.isVisible = true;
            this.showPlot = showPlot
        },
        aiPlot() {
            this.plot = ''
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            this.AIWrite({
                length: '长',
                haveId: true,
                type: 'series_continue_plot',
                params: {
                    novelId: this.novelId || editItem.novelInfo.id,
                },
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // lNApi.longNovelHelpWriteId('series_continue_plot',
            //     {
            //         novelId: this.novelId || editItem.novelInfo.id,
            //     }
            // ).then((res) => {
            //     if (res.code == 200) {
            //         this.streamStatus = true
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     }else{
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamStatus = false
                                    this.clearTimer()
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！')
                                    return;
                                }
                                this.getStreamContent(id);
                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                    }
                });
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.plot += text[index]
                    // this.markedContent = marked(this.content)
                    index++;
                    this.$nextTick(() => {
                        const container = this.$refs.editorTextContext2;
                        if (container) {
                            container.scrollTop = container.scrollHeight; // 直接滚动到底部
                        }
                    });
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        aiGenerateoutline() {
            if (!this.chapter) {
                this.$message.warning('请填写续写的分卷数！')
                return
            }
            if (this.chapter > this.maxChapter) {
                this.$message.warning(`续写分卷数超过范围，已同步最大范围`)
                this.chapter = this.maxChapter
                return
            }
            let continued = {
                plot: this.plot,
                chapter: this.chapter
            }
            this.$emit('getContinued', continued)
            this.plot = ''
            this.chapter = ''
            this.closePopup()
        }
    }
}

</script>
<style>
#outline_continuous {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.outline_continuous {
    padding: 25px 0;
    background: #FFFFFF;
    border-radius: 10px;
}

.outline_continuous1 {
    width: 530px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 35px;
    border-bottom: 1px solid #DDDDDD;
    padding-bottom: 20px;
    font-weight: bold;
    font-size: 19px;
    color: #111111;
}

.outline_continuous1 img {
    width: 21px;
    height: 21px;
}

.outline_loading {
    width: 21px;
    height: 21px;
    animation: rotate 1s linear infinite;
}

.outline_continuous2 {
    width: 530px;
    display: flex;
    align-items: center;
    padding: 0 35px;
    margin-top: 20px;
}

.outline_continuous3 {
    font-weight: bold;
    font-size: 17px;
    color: #111111;
    flex: 1;
}

.outline_continuous3 span {
    color: #FF0000;
}

.outline_continuous4 {
    /* width: 58px;
    height: 25px; */
    width: 85px;
    height: 32px;
    background: url('@/assets/image/icon_create1.png') no-repeat;
    background-size: 100% 100%;
}

.outline_continuous4:hover {
    background: url('@/assets/image/icon_create2.png') no-repeat;
    background-size: 100% 100%;
}

#outline_continuous .el-input__inner {
    width: 460px;
    margin-top: 10px;
    margin-left: 35px;
    border: none;
    background-color: #FAFAFA;
}

.outline_continuous5 {
    width: 460px;
    background-color: #FAFAFA;
    margin: 0 auto;
    margin-top: 10px;
    border-radius: 4px;
    position: relative;
}

.outline_continuous5 .el-input__count {
    background-color: transparent !important;
}

#outline_continuous .el-textarea__inner {
    width: 100%;
    border: none;
    resize: none;
    padding-bottom: 20px;
    background-color: #FAFAFA;
}


.outline_continuous6 img {
    width: 15px;
    height: 15px;
    position: absolute;
    bottom: 5px;
    left: 15px;
}

.outline_continuous7 {
    width: 460px;
    margin: 0 auto;
    display: flex;
    justify-content: end;
    margin-top: 15px;
}

.outline_continuous8 {
    width: 125px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
    cursor: pointer;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>